<template>
  <!-- 编辑模态框 -->
  <el-dialog title="导入报备数据" :visible.sync="dialogVisible" top="20px">
    <div class="border p-3 rounded">
      <div class="yh-section-title">导入指引</div>
      <p v-html="tip" class="el-upload__tip" style="line-height: 18px;"></p>

      <el-upload ref="upload" class="upload-demo" :multiple="false" :limit="1"
                 action=""
                 :auto-upload=true
                 :accept="accept"
                 :before-upload="handleBeforeUpload"
                 :before-remove="handleBeforeRemove"
                 :headers="headers"
                 :http-request="uploadRegistrationFile"
                 :on-success="handleUploadSuccess"
                 :on-error="handleUploadError">
        <el-button v-if="$perm(['registration.import_registration'])" slot="trigger" size="mini"
                   type="primary">上传报备数据
        </el-button>
      </el-upload>
    </div>
    <div class="mt-3 clearfix">
      <span class="float-right">
        <el-button size="small" type="primary" @click="handleClose">关闭</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
  /* eslint-disable */

  import {getToken} from '@/utils/auth'
  import {uploadRegistrationFile} from '@/api/upload'

  export default {
    name: 'registration-dialog',
    data() {
      return {
        tip: '<span>1. 报备数据文件为EXCEL文件(.xls, .xlsx)，文件第一行为标题，导入时将忽略。<br>' +
          '2. 系统只读取询价列表文件的第一页，因此，所有的报备数据应放在第一页<br>' +
          '3. 字段格式为：起保日期、船名、被保险人、险种、推荐人（部门）、业务区域、实际控制人、联系人、联系电话、备注（公司业务/个人业务/间接业务）<br></span>',
        accept: '.xls,.xlsx',
        temp: {},
        dialogVisible: false,
        rules: {}
      }
    },
    computed: {
      headers() {
        return {'Authorization': 'Token ' + getToken()}
      }
    },
    methods: {
      handleRegistrationImport() {
        this.dialogVisible = true
      },
      handleClose() {
        this.$refs.upload.clearFiles()
        this.dialogVisible = false
        this.$emit('updateList')
      },
      handleBeforeUpload(file) {
        let uploadFlag = true, processing_file = file
        // const isLt10M = file.size / 1024 / 1024 < 10;

        /*
        if(!isLt10M) {
          this.$message.error(`上传的文件大小不能超过10MB，文件${file.name}大小超出限制`);
          uploadFlag = false;
        }
        */

        // 检查是否重复上传
        this.$refs.upload.uploadFiles
          .filter(file => file.status == 'success')
          .forEach(file => {
            if (file.name == processing_file.name && file.size == processing_file.size) {
              this.$message.warning('文件已经存在，请勿重复上传')
              uploadFlag = false
              return
            }
          })

        return uploadFlag
      },
      handleBeforeRemove(file, filelist) {
        if (file.status == 'success') {
          this.$message.error('已经上传的文件不能删除')
          return false
        }
      },
      handleUploadSuccess(res, file, fileList) {
        this.$message.success(res)
      },
      handleUploadError(error, file, fileList) {
        error_message(error)
      },
      uploadRegistrationFile(param) {
        let fileObj = param.file
        let fd = new FormData()

        if (!this.handleBeforeUpload(fileObj)) return

        fd.append('file', fileObj)

        // 其他参数
        // fd.append('object_type', this.object_type)
        // fd.append('object_id', this.object_id)
        // fd.append('remark_name', this.upload.remark_name)
        uploadRegistrationFile(fd)
          .then(res => {
            // this.$message.success(res.data.message)
            param.onSuccess(res.message)
          })
          .catch(error => {
            param.onError(error)
          })
      }
    }
  }
</script>
